const initialState = {
  testimonials: null,
}

export default initialState;
